import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "task-slider" }
const _hoisted_2 = {
  key: 0,
  class: "task-slider__header"
}
const _hoisted_3 = {
  key: 1,
  class: "task-slider__filter"
}

import { ref, computed, useSlots } from 'vue'

// Components
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation } from 'swiper'
import 'swiper/css'
import TaskCard from '@/components/TaskCard'
import Title from '@/components/ui/Title'

// i18n
import { useI18n } from 'vue-i18n'

import { Props } from '@/components/TaskSlider'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'TaskSlider',
  props: {
    title: {},
    items: {},
    routeName: {},
    isLoading: { type: Boolean },
    init: { type: Boolean, default: true },
    emptyText: { default: null }
  },
  setup(__props: any) {

const { t } = useI18n()

// Types
const props = __props

// Data
const prev = ref(null)
const next = ref(null)
const modules = [Navigation]
const slots = useSlots()

// Computed
const hasSlot = computed<boolean>(() => !!slots.filter)
const showHeader = computed<boolean>(() => Boolean(props.title?.length || hasSlot))
const EmptyText = computed<string>(() => props.emptyText ?? t('common.noData'))
const isEmpty = computed<boolean>(()=> Boolean(!props.items?.length))

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showHeader.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (showHeader.value)
            ? (_openBlock(), _createBlock(_unref(Title), {
                key: 0,
                theme: "medium",
                class: "task-slider__title"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showHeader.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "filter")
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (isEmpty.value && _ctx.init)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["task-slider__empty", {'task-slider__empty_loading': _ctx.isLoading}])
        }, _toDisplayString(EmptyText.value), 3))
      : _createCommentVNode("", true),
    (!isEmpty.value || !_ctx.init)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["task-slider__wrapper", {'task-slider__wrapper_loading': _ctx.isLoading}])
        }, [
          _createElementVNode("div", {
            class: "task-slider__arrow task-slider__arrow_prev",
            ref_key: "prev",
            ref: prev
          }, [
            _createVNode(_component_draw_svg, {
              name: "arrow-pink",
              width: "30",
              height: "30"
            })
          ], 512),
          _createVNode(_unref(Swiper), {
            class: "task-slider__swiper",
            "slides-per-view": "auto",
            "space-between": 7,
            navigation: {
          prevEl: prev.value,
          nextEl: next.value,
          disabledClass: 'task-slider__arrow_disabled'
        },
            modules: modules
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createBlock(_unref(SwiperSlide), { class: "task-slider__swiper-slide" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TaskCard), { item: item }, null, 8, ["item"])
                  ]),
                  _: 2
                }, 1024))
              }), 256))
            ]),
            _: 1
          }, 8, ["navigation"]),
          _createElementVNode("div", {
            class: "task-slider__arrow task-slider__arrow_next",
            ref_key: "next",
            ref: next
          }, [
            _createVNode(_component_draw_svg, {
              name: "arrow-pink",
              width: "30",
              height: "30"
            })
          ], 512)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})